(function () {
  window.setCookie = window.setCookie || function (name, value, days) {
    const expires = days ? `; expires=${new Date(Date.now() + days * 86400000).toUTCString()}` : '';
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value || '')}${expires}; path=/; SameSite=Lax; Secure`;
  };

  window.commonGtmEvent = window.commonGtmEvent || function (category, operating, label) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'common', category, operating, label });
  };

  window.autoDiscountCode = window.autoDiscountCode || async function (code) {
    if (!code) return;
    window.setCookie('discount_code', code, 1);
    const deadline = Date.now() + 4000;
    while (!window.discountOnCartProApp?.applyCode && Date.now() < deadline) {
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    if (typeof window.discountOnCartProApp?.applyCode === 'function') {
      const applied = window.discountOnCartProApp.codes || [];
      if (!applied.some(value => String(value).toLowerCase() === String(code).toLowerCase())) {
        await window.discountOnCartProApp.applyCode(code);
      }
    }
  };

  window.buyProduct = window.buyProduct || async function (productId, properties, code, quantity = 1) {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: productId, quantity, properties: properties || {} })
    });
    if (!response.ok) throw new Error(`Buy now failed: ${response.status}`);
    if (code) await window.autoDiscountCode(code);
    window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
  };

  if (!/^\/products\/ulike-reglow-led-light-therapy-mask\/?$/.test(window.location.pathname)) return;

  const productHandle = 'ulike-reglow-led-light-therapy-mask';
  let productRequest;

  function getProduct() {
    if (!productRequest) {
      productRequest = fetch(`${window.Shopify?.routes?.root || '/'}products/${productHandle}.js`, {
        credentials: 'same-origin'
      }).then(response => {
        if (!response.ok) throw new Error(`ReGlow product request failed: ${response.status}`);
        return response.json();
      });
    }
    return productRequest;
  }

  function selectedOptions(picker) {
    return Array.from(picker.querySelectorAll('input[name^="option"]:checked, select[name^="option"]'))
      .sort((a, b) => Number(a.name.replace('option', '')) - Number(b.name.replace('option', '')))
      .map(input => input.value);
  }

  async function selectReGlowVariant(picker) {
    const form = document.getElementById(picker.getAttribute('form-id'));
    if (!form) return;
    const options = selectedOptions(picker);
    let variant;
    try {
      const product = await getProduct();
      variant = product.variants.find(item => item.options.every((value, index) => value === options[index]));
    } catch (error) {
      const swatches = Array.from(picker.querySelectorAll('input[name="option1"]'));
      const index = swatches.findIndex(input => input.value === options[0]);
      const fallback = window.variantArr?.[index];
      if (fallback) variant = { id: Number(fallback.vid), title: options.join(' / '), options };
    }
    if (!variant?.id) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.disabled = false;
      variantInput.value = String(variant.id);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    options.forEach((value, index) => {
      const valueLabel = picker.querySelector(`[id$="-${index + 1}-value"]`);
      if (valueLabel) valueLabel.textContent = value;
    });
    if (picker.hasAttribute('update-url')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }
    const detail = { variant };
    form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail }));
    form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail }));
  }

  async function copyCode(code) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(code);
        return true;
      } catch (error) {
      }
    }
    const input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.cssText = 'position:fixed;left:-9999px;top:0';
    document.body.appendChild(input);
    input.select();
    try {
      return document.execCommand('copy');
    } catch (error) {
      return false;
    } finally {
      input.remove();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const picker = document.querySelector(`product-variants[handle="${productHandle}"]`);
    if (!picker || window.customElements.get('product-variants')) return;
    getProduct().catch(() => {});
    picker.addEventListener('change', event => {
      if (/^option\d+$/.test(event.target.name)) selectReGlowVariant(picker);
    });
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('.product-new quantity-selector .quantity-selector__button');
    if (!button) return;
    const selector = button.closest('quantity-selector');
    const input = selector?.querySelector('input[name="quantity"]');
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const buttons = Array.from(selector.querySelectorAll('.quantity-selector__button'));
    const delta = button === buttons[0] ? -1 : 1;
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Number.MAX_SAFE_INTEGER;
    input.value = String(Math.min(max, Math.max(min, (Number(input.value) || min) + delta)));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  document.addEventListener('click', event => {
    const button = event.target.closest('.product-info-new .btn-copy-block');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const code = button.querySelector('.code')?.textContent.trim();
    if (!code) return;
    copyCode(code).then(() => {
      if (typeof disCode !== 'undefined') disCode = code;
      window.autoDiscountCode(code);
      window.commonGtmEvent(`ReGlow Product-copy ${code}`, '', 'Product');
      const success = button.parentElement.querySelector('.copy-success');
      button.style.display = 'none';
      success?.classList.add('show');
      window.setTimeout(() => {
        success?.classList.remove('show');
        button.style.removeProperty('display');
      }, 3000);
    });
  }, true);
})();
